<template>
  <div class="container">
    <section class="section">
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="box">
            <h1 class="title is-5">Cambiar el código de los productos</h1>
            <h2 class="subtitle">
              Podra subir un archivo de excel con el codigo viejo y el código
              nuevo para cambiar los códigos de los productos
            </h2>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <button class="button is-link" @click="downexemple">
                  Descargar Ejemplo
                </button>
              </div>
              <div class="column">
                <div class="field">
                  <div class="file is-light">
                    <label class="file-label" style="margin-left: 10px">
                      <input
                        class="file-input"
                        type="file"
                        accept=".xls, .xlsx"
                        @change="onFileChange"
                        name="resume"
                      />
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="material-icons">cloud_upload</i>
                        </span>
                        <span class="file-label">Cargar desde Excel</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <progress
                  v-show="avaceupload > 0"
                  class="progress is-info is-small"
                  :value="avaceupload"
                  max="100"
                ></progress>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="box">
            <h1 class="title is-5">
              Agregarle la columna structure al producto
            </h1>
            <h2 class="subtitle">
              Esta columna se le agregara a los productos para agruparlos por
              alguna referencia
            </h2>
            <p>
              Debe indicar cuantos caracteres del codigo se tomaran para crear
              la referencia
            </p>
            <br />
            <div class="field has-addons">
              <div class="control">
                <input
                  v-model="caracter"
                  class="input"
                  type="number"
                  placeholder="Número de caracteres"
                />
              </div>
              <div class="control">
                <a class="button is-link" @click="createSubstructure">Crear</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      avaceupload: 0,
      query: {
        url: "",
      },
      caracter: 0,
    };
  },
  methods: {
    async createSubstructure() {
      try {
        await apiServices.post(`/createsubstructure`, {
          caracter: this.caracter,
        });
      } catch (err) {
        console.log(err);
      }
    },
    async downexemple() {
      try {
        let result;
        result = await apiServices.post(
          `/downexemplecodeinventory`,
          { np: "np" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.avaceupload = 0;
              _this.query.url = url;
              const result = await apiServices.post(
                `/uploadcodeinventory`,
                this.query
              );
              console.log(result);
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/inventory/Inventory.vue